import { render, staticRenderFns } from "./VuesticColorInput.vue?vue&type=template&id=5be0a8c2&scoped=true&"
import script from "./VuesticColorInput.vue?vue&type=script&lang=js&"
export * from "./VuesticColorInput.vue?vue&type=script&lang=js&"
import style0 from "./VuesticColorInput.vue?vue&type=style&index=0&id=5be0a8c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be0a8c2",
  null
  
)

component.options.__file = "VuesticColorInput.vue"
export default component.exports